// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"8751a8d8","453":"014cd678","492":"ffb485c0","591":"9d8230b0","615":"16d4225a","736":"164546f8","793":"aca43c8f","818":"08f58e8f","900":"1d3cfc5b"}[chunkId] + ".chunk.js";
};